/* Quest 1 -> Hall. Only the random handoff ID travels in the URL.
   Text has a 24-hour local fallback; IndexedDB carries the original portraits.
   This module never sends leads, marketing events, or messages. */
(function(){
  'use strict';
  var PREFIX='ffq-hall-v1:', AGE=24*60*60*1000, ready={}, dbPromise;
  function validId(id){return /^[a-f0-9-]{36}$/i.test(id||'');}
  function email(value){return String(value||'').trim().toLowerCase();}
  function valid(d){return d&&d.version===1&&d.source==='quest1'&&validId(d.key)&&d.createdAt<=Date.now()+60000&&Date.now()-d.createdAt<AGE;}
  function database(){
    if(!dbPromise) dbPromise=new Promise(function(resolve){
      var settled=false, timer=setTimeout(function(){finish(null);},2500);
      function finish(db){if(settled){if(db)db.close();return;}settled=true;clearTimeout(timer);resolve(db);}
      try{
        var req=indexedDB.open('ffq-hall-handoff',1);
        req.onupgradeneeded=function(){req.result.createObjectStore('drafts',{keyPath:'key'});};
        req.onsuccess=function(){finish(req.result);};
        req.onerror=req.onblocked=function(){finish(null);};
      }catch(_){finish(null);}
    });
    return dbPromise;
  }
  function transact(mode,run){
    return database().then(function(db){
      if(!db)return null;
      return new Promise(function(resolve){
        var value=null, done=false, timer=setTimeout(function(){finish(null);},2500);
        function finish(v){if(done)return;done=true;clearTimeout(timer);resolve(v);}
        try{
          var tx=db.transaction('drafts',mode);
          run(tx.objectStore('drafts'),function(v){value=v;});
          tx.oncomplete=function(){finish(value);};
          tx.onerror=tx.onabort=function(){finish(null);};
        }catch(_){finish(null);}
      });
    });
  }
  function save(d,files){
    if(!valid(d))return Promise.resolve(false);
    d.portraitCount=(files||[]).length;
    try{
      Object.keys(localStorage).filter(function(k){return k.indexOf(PREFIX)===0;}).forEach(function(k){
        try{if(!valid(JSON.parse(localStorage.getItem(k))))localStorage.removeItem(k);}catch(_){}
      });
      localStorage.setItem(PREFIX+d.key,JSON.stringify(d));ready[d.key]=true;
    }catch(_){}
    return transact('readwrite',function(store,set){
      store.put({key:d.key,draft:d,files:(files||[]).slice(0,2)});set(true);
      var cursor=store.openCursor();
      cursor.onsuccess=function(){var c=cursor.result;if(c){if(!valid(c.value.draft))c.delete();c.continue();}};
    }).then(function(ok){if(ok)ready[d.key]=true;return !!ready[d.key];});
  }
  function read(key){
    if(!validId(key))return Promise.resolve(null);
    return transact('readonly',function(store,set){var r=store.get(key);r.onsuccess=function(){set(r.result);};}).then(function(row){
      var d=row&&row.draft;
      try{var local=JSON.parse(localStorage.getItem(PREFIX+key));if(valid(local))d=local;}catch(_){}
      return valid(d)?{draft:d,files:(row&&row.files)||[]}:null;
    });
  }
  function story(bp){
    var parts=[],title=String(bp.archetypeTitle||'').trim(),tag=String(bp.archetypeTagline||'').trim();
    if(bp.definingMoment)parts.push('Defining moment:\n'+String(bp.definingMoment).trim());
    if(title||tag)parts.push('Archetype: '+(title?("You're the "+title+'. '):'')+tag);
    if(bp.personality)parts.push('Personality: '+String(bp.personality).trim());
    return parts.join('\n\n');
  }
  function fromQuest(bp,transfer,artifacts){
    var debug=email(bp.name)==='jangela',sample=false;
    if(debug){
      bp=Object.assign({},bp);
      var demo={race:'Half-Elf',charClass:'Ranger',playerName:'Jangela',email:'jangela@example.test',campaign:'The Long Road',
        personality:'Loyal, Curious',definingMoment:'When the bridge fell, Jangela went back for the last traveler. They spent the night on the far bank, keeping a fire lit until the party found them.'};
      Object.keys(demo).forEach(function(k){if(!bp[k]){bp[k]=demo[k];sample=true;}});
    }
    var traits=String(bp.personality||'').split(/[,;\n]+/).map(function(t){return t.trim();}).filter(function(t){return t&&t.length<=32;}).slice(0,3);
    return {version:1,source:'quest1',key:transfer.key,createdAt:Date.now(),
      heroId:transfer.heroId,originName:bp.name,debug:debug,debugSample:sample,
      hero:{name:bp.name,race:bp.race,character_class:bp.charClass,level:bp.level,
        campaign:bp.campaign||'',player_name:bp.playerName||'',email:email(bp.email),
        story:story(bp),card_meta:{personality_traits:traits},image_url:transfer.urls[0]||null,image_url_2:transfer.urls[1]||null,
        share_card_url:artifacts.card||null,blueprint_pdf_url:artifacts.pdf||null}};
  }
  function result(res,message){if(!res||res.error)throw new Error(message);return res.data;}
  async function find(sb,d,cols){
    var rows=result(await sb.from('characters').select(cols).eq('id',d.heroId).limit(1),'Could not load your Quest hero. Please try again.');
    if(!rows.length){
      rows=result(await sb.from('characters').select(cols).eq('auth_email',email(d.hero.email)).eq('name',d.originName).limit(2),'Could not check your Quest hero. Please try again.');
      if(rows.length>1)throw new Error('More than one hero has this name. Claim the right one from Your Hall.');
    }
    var c=rows[0]||null;
    if(c&&email(c.auth_email||c.email)!==email(d.hero.email))throw new Error('This hero belongs to another Hall account. Reopen the link from your Quest.');
    return c;
  }
  function merge(d,c){
    var hero=Object.assign({},d.hero);
    // The existing owner's words and portrait always win on a retake.
    if(c)Object.keys(c).forEach(function(k){if(c[k]!==null&&c[k]!==undefined&&c[k]!=='')hero[k]=c[k];});
    hero.email=email(d.hero.email);return hero;
  }
  // A Hall sign-in by Google or an emailed code ('g1.' + 64 hex, HALL-SIGNIN-03) stands in for the PIN: verify_pin counts
  // the account's heroes for a live session. An email with no hero yet counts 0 until this one is in, so 0 is not refused
  // before the insert; set_pin refuses a session that isn't live after it.
  var SESSION=/^g1\.[0-9a-f]{64}$/;
  async function authorize(sb,d,pin){
    if(SESSION.test(pin||'')){
      var n=result(await sb.rpc('verify_pin',{user_email:email(d.hero.email),user_pin:pin}),'Could not check your Hall sign-in. Please try again.');
      return typeof n==='number'&&n>0;
    }
    if(!/^\d{4}$/.test(pin||''))throw new Error('Enter a 4 digit Hall PIN. Use your existing PIN if you already have one.');
    var has=result(await sb.rpc('email_has_pin',{user_email:email(d.hero.email)}),'Could not check your Hall PIN. Please try again.');
    if(has!==true&&has!==false)throw new Error('Could not check your Hall PIN. Please try again.');
    if(has){
      var count=result(await sb.rpc('verify_pin',{user_email:email(d.hero.email),user_pin:pin}),'Could not verify your Hall PIN. Please try again.');
      if(!(typeof count==='number'&&count>0))throw new Error('That PIN does not match. Enter your existing Hall PIN.');
    }
    return has;
  }
  var FIELDS=['name','race','character_class','level','campaign','player_name','story','image_url','image_url_2',
    'image_thumb_url','image_thumb_url_2','image_offset_y','image_offset_y_2','image_offset_x','image_offset_x_2',
    'image_zoom','image_zoom_2','is_animated','is_animated_2','is_ff_portrait','card_meta','stats_block','phone_number','sms_optin',
    'npc_current_goal','npc_hidden_weakness','npc_habit','npc_catchphrase','npc_secret','npc_enemy'];
  function checkModeration(c){
    var qm=c&&c.quest_meta||{};
    if(c&&c.is_hidden===true&&(qm.review_state==='rejected'||qm.review_state==='needs_image'||qm.hidden_reason||
      !(qm.from_quest===true||qm.from_quest==='true'||qm.source==='iron-matron'))){
      throw new Error('This hero needs attention in Your Hall before it can be published.');
    }
  }
  async function publish(sb,d,payload,pin,cols){
    if(d.debug)throw new Error('Preview characters cannot be published.');
    var c=await find(sb,d,cols), qm=c&&c.quest_meta||{};
    // A replay of the same final tap returns its receipt, without new rewards.
    if(qm.hall_handoff_id===d.key&&c.approved===true&&c.is_hidden===false)return c;
    checkModeration(c);
    var has=await authorize(sb,d,pin);
    if(!c){
      // player_name, race and class are NOT NULL: a caller without one (the Quest) seeds '' and the INSERT trigger fills a known email's name.
      var seed=Object.assign({},payload,{id:d.heroId,player_name:payload.player_name||'',race:payload.race||'',character_class:payload.character_class||'',email:email(d.hero.email),auth_email:email(d.hero.email),
        approved:true,is_hidden:true,quest_meta:Object.assign({},payload.quest_meta||{},{source:'iron-matron',from_quest:true,version:1,earned:['iron-matron'],review_state:'pending'})});
      // Share the Quest's reserved UUID, even when its slow save is still running.
      var inserted=await sb.from('characters').insert([seed]).select(cols);
      if(inserted&&inserted.error&&inserted.error.code==='23505')c=await find(sb,d,cols);
      else c=(result(inserted,'Could not save your hero. Please try again.')||[])[0];
      if(!c)throw new Error('Could not confirm your hero was saved. Please try again.');
    }
    checkModeration(c);
    // PIN hashes belong to individual rows. Attach the verified existing PIN to
    // this new Quest row too, so returning players can find it in Your Hall.
    // A Hall session as the new PIN sets none: the account's own PIN, if it has one, goes onto this row.
    var signed=SESSION.test(pin||'');
    var set=result(await sb.rpc('set_pin',{user_email:email(d.hero.email),old_pin:has&&!signed?pin:null,new_pin:pin}),'Could not set your Hall PIN. Please try again.');
    if(set!==true)throw new Error(signed?'Your Hall sign-in has run out. Sign in again, then tap again.':'Could not set your Hall PIN. Try your existing PIN.');
    if(!await authorize(sb,d,pin))throw new Error(signed?'Your Hall sign-in has run out. Sign in again, then tap again.':'Your Hall PIN was not saved. Please try again.');
    qm=Object.assign({},c.quest_meta||{});
    var update={};FIELDS.forEach(function(k){if(Object.prototype.hasOwnProperty.call(payload,k))update[k]=payload[k];});
    update.tickets=c.tickets==null?1:c.tickets;
    ['npcTicketGranted','statsTicketGranted'].forEach(function(k){
      if(payload.quest_meta&&payload.quest_meta[k]&&!qm[k]){qm[k]=true;update.tickets++;}
    });
    if(payload.is_ff_portrait&&!c.ff_bonus_granted){update.tickets+=10;update.ff_bonus_granted=true;}
    // Preserve all Quest artifacts, rewards, and moderation history.
    if(!c.share_card_url&&d.hero.share_card_url)update.share_card_url=d.hero.share_card_url;
    if(!c.blueprint_pdf_url&&d.hero.blueprint_pdf_url)update.blueprint_pdf_url=d.hero.blueprint_pdf_url;
    qm.review_state='approved';qm.hall_handoff_id=d.key;qm.hall_submitted_at=new Date().toISOString();
    update.quest_meta=qm;update.approved=true;update.is_hidden=false;
    var saved=(result(await sb.from('characters').update(update).eq('id',c.id).eq('auth_email',email(d.hero.email)).select(cols),
      'Could not publish your hero. Your details are still here. Please try again.')||[])[0];
    if(!saved||saved.approved!==true||saved.is_hidden!==false)throw new Error('Your hero is saved, but publication was not confirmed. Please try again.');
    return saved;
  }
  window.FFQuestHall={save:save,read:read,ready:function(k){return !!ready[k];},fromQuest:fromQuest,
    story:story,find:find,merge:merge,authorize:authorize,publish:publish};
})();
